module.exports = __webpack_public_path__ + "static/image-pradeep-0de58cd8966663c20fafd831ab3bf9a3.svg";